import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Container, Row, Col } from 'react-bootstrap';
import LogoBanner from "../components/logobanner.png";

const NotFound = () => (
    <Container fluid className="bg-dark text-light" style={{ minHeight: '100vh' }}>
        <Helmet>
            <title>RetireSecure | Page Not Found</title>
            <meta name="robots" content="noindex" />
        </Helmet>
        <Row style={{ paddingTop: '80px' }}>
            <Col xs={0} sm={1} />
            <Col xs={12} sm={10} className="rounded p-3 mt-2 mb-2">
                <img src={LogoBanner} alt="RetireSecure" style={{ width: '400px', height: 'auto', maxWidth: '100%' }} />
                <div className="my-4" />
                <h1 className="lead" style={{ fontSize: '1.4rem', fontWeight: 600 }}>Page not found</h1>
                <hr className="my-1" />
                <p className="mt-3">The page you were looking for does not exist.</p>
                <p>
                    <Link className="btn btn-primary" to="/">Go to home page</Link>
                </p>
            </Col>
            <Col xs={0} sm={1} />
        </Row>
    </Container>
);

export default NotFound;
